<template>
  <div>
    <h1 class="h2 mt-4">Díjfizetés És Kedvezmények</h1>
    <div class="mb-3">
      <div class="w-100 label pb-2">
        <b
          >Milyen díjfizetési módot szeretne választani?
          <span class="text-danger">*</span>
          <button
            class="info"
            id="dijfizetes_modja-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            type="button"
          >
            ?
          </button></b
        >
      </div>
      <div class="row">
        <input type="text" hidden v-model="paymentType" name="dijfizetes_mod" />
        <div class="col-md-3 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'online'"
            :class="{
              'btn-red': paymentType == 'online',
              'btn-outline-danger': paymentType !== 'online',
            }"
          >
            Online bankkártyás fizetés
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'csoportos'"
            :class="{
              'btn-red': paymentType == 'csoportos',
              'btn-outline-danger': paymentType !== 'csoportos',
            }"
          >
            Csoportos beszedési megbízás
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'atutalas'"
            :class="{
              'btn-red': paymentType == 'atutalas',
              'btn-outline-danger': paymentType !== 'atutalas',
            }"
          >
            Átutalás
          </button>
        </div>
        <div class="col-md-3 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'csekk'"
            :class="{
              'btn-red': paymentType == 'csekk',
              'btn-outline-danger': paymentType !== 'csekk',
            }"
          >
            Postai csekk
          </button>
        </div>
      </div>
      <small
        id="dijfizetes_modja-error"
        class="text-danger input-alert"
      ></small>
    </div>
    <div v-if="paymentType === 'csoportos'">
      <h1 class="h2 mt-4">Bank adatok</h1>
      <div class="row justify-content-end">
        <ValidationProvider
          rules="required|bankszamlaszam|bankszamlaszam_alg"
          v-slot="{ errors, classes }"
          class="col-md-8 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span
                class="input-group-text"
                id="szerzodo_bankszamlaszam_prepend"
                >Számlaszám: <span class="text-danger">*</span></span
              >
            </div>
            <input
              v-mask="'########-########-########'"
              type="text"
              class="form-control"
              id="szerzodo_bankszamlaszam"
              name="szerzodo_bankszamlaszam"
              v-model="bankAccountNumber"
              aria-label="szerzodo_bankszamlaszam"
              aria-describedby="szerzodo_bankszamlaszam_prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small
            id="szerzodo_bankszamlaszam-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="row justify-content-end">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-md-8 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="sszerzodo_bankneve_prepend"
                >Bank neve: <span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="szerzodo_bankneve"
              name="szerzodo_bankneve"
              v-model="bankName"
              aria-label="szerzodo_bankneve"
              aria-describedby="szerzodo_bankneve_prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small id="szerzodo_bankneve-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row justify-content-end">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-md-8 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span
                class="input-group-text"
                id="szerzodo_szamlatulajdonosneve_prepend"
                >Számlatulajdonos neve: <span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="szerzodo_szamlatulajdonosneve"
              name="szerzodo_szamlatulajdonosneve"
              v-model="bankAccountHolderName"
              aria-label="szerzodo_szamlatulajdonosneve"
              aria-describedby="szerzodo_szamlatulajdonosneve_prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small
            id="szerzodo_szamlatulajdonosneve-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Megkötés oka?
        <span class="text-danger">*</span>
        <button
          class="info"
          id="kotes_oka-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="kotes_oka"
            id="uj_szerzodes"
            :value="'uj_szerzodes'"
            v-model="contractReason"
          />
          <label class="form-check-label" for="uj_szerzodes">
            Új lakásbiztosítás megkötése a Colonnade-nél
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="kotes_oka"
            id="jelenlegi_atkotese"
            :value="'atkotes'"
            v-model="contractReason"
          />
          <label class="form-check-label" for="jelenlegi_atkotese">
            Jelenlegi Colonnade lakásbiztosításom átkötése (amennyiben ezt
            választja, külön nyilatkoznia kell a túlfizetés , díjtartozás
            kapcsán)
          </label>
        </div>
        <small id="kotes_oka-error" class="text-danger input-alert"></small>
      </div>
    </div>

    <div v-if="contractReason === 'atkotes'" class="form-group row">
      <label class="col-sm-4" for="regi_kotvenyszam"
        >Jelenlegi kötvény száma:</label
      >
      <div class="col-sm-8">
        <ValidationProvider
          :immediate="true"
          rules="required"
          v-slot="{ errors }"
        >
          <input
            class="form-control mb-2 dark-border"
            type="text"
            id="regi_kotvenyszam"
            name="regi_kotvenyszam"
            v-model="oldContructNumber"
          />
          <small id="regi_kotvenyszam-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Milyen díjfizetési gyakorisággal szeretné fizetni a szerződés díját?
        <span class="text-danger">*</span>
        <button
          class="info"
          id="dijfizetes_gyakorisaga-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button></label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_year"
            :value="'eves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_year">
            Éves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_halfyear"
            :value="'feleves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_halfyear">
            Féléves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_quarterly"
            :value="'negyedeves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_quarterly">
            Negyedéves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_month"
            :value="'havi'"
            :disabled="!canChooseMonthlyPayment"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_month">
            Havi
          </label>
        </div>
        <small
          id="dijfizetes_gyakorisaga-error"
          class="text-danger input-alert"
        ></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Szeretné, ha a Biztosító (postai levelezés helyett) elektronikus
        formában kommunikálna Önnel? <span class="text-danger">*</span>
        <button
          class="info"
          id="elektronikus_kommunikacio-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button>
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_igen"
            :value="1"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_nem"
            :value="0"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kommunikáció választásakor további -5% kedvezményt adunk
          az éves díjból.</small
        ><br />
        <span v-if="!electronicContact"
          ><small class="text-warning fw-bold input-alert">
            Ebben az esetben az összes dokumentumot kinyomtatjuk és postán is
            küldjük Önnek. Ez egy sokkal lassabb és környezetszennyezőbb
            folyamat, valamint így nem takarít meg 5%-ot a végső árból. </small
          ><br
        /></span>

        <small
          id="elektronikus_kommunikacio-error"
          class="text-danger input-alert"
        ></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4">
        Szeretné a kárrendezést (személyes ügyintézés vagy postai levelezés
        helyett) elektronikusan/digitálisan végezni?
        <span class="text-danger">*</span>
        <button
          class="info"
          id="elektronikus_karrendezes-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button>
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_igen"
            :value="1"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_nem"
            :value="0"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kárrendezés választásakor további -5% kedvezményt adunk
          az éves díjból.</small
        ><br />
        <small id="ekarrendezes-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4" for="kedvezmenykod_input">
        Kedvezménykód:
      </label>
      <div class="col-sm-8">
        <div class="input-group mb-2">
          <input
            class="form-control dark-border"
            type="text"
            id="kedvezmenykod_input"
            v-model="couponCodeInput"
            :disabled="couponCodeApplied"
          />

          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-red w-100"
              @click="handleCouponCode"
            >
              {{
                couponCodeApplied
                  ? "Kód eltávolítása"
                  : "Kedvezménykód Aktiválása"
              }}
            </button>
          </div>
        </div>
        <input
          type="hidden"
          id="kedvezmenykod"
          name="kedvezmenykod"
          v-model="couponCode"
        />

        <div
          v-if="fieldErrors.kedvezmenykod"
          class="input-alert"
          :class="
            fieldErrors.kedvezmenykod === 'Nem létező kedvezménykód'
              ? 'text-danger'
              : 'text-success'
          "
        >
          {{ fieldErrors.kedvezmenykod }}
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="upol">
      <label class="col-sm-4" for="uzletpolitikai"
        >Kockázati kedvezmény<span class="text-danger">*</span>:</label
      >
      <div class="col-sm-8">
        <ValidationProvider
          :rules="{
            required: true,
            integer: true,
            min_value: 0,
            max_value: uzletpolitikai_max,
          }"
          v-slot="{ errors }"
        >
          <input
            class="form-control mb-2 dark-border"
            type="number"
            id="uzletpolitikai"
            name="uzletpolitikai"
            v-model.lazy="businessDiscount"
          />
          <small id="uzletpolitikai-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div v-show="false" class="form-group row mb-3">
      <label class="col-sm-4">
        Igénybe szeretné venni az életkor alapú kedvezményünket?
        <span class="text-danger">*</span>
        <button
          class="info"
          id="eletkorkedvezmeny-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button>
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="eletkorkedvezmeny"
            id="eletkorkedvezmeny_igen"
            :value="1"
            v-model="ageDiscount"
          />
          <label class="form-check-label" for="eletkorkedvezmeny_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="eletkorkedvezmeny"
            id="eletkorkedvezmeny_nem"
            :value="0"
            v-model="ageDiscount"
          />
          <label class="form-check-label" for="eletkorkedvezmeny_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >A kedvezmény a következő oldalon megadott életkorból kerül
          kiszámításra</small
        ><br />
        <small
          id="eletkor_kedvezmeny-error"
          class="text-danger input-alert"
        ></small>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      frequencyPrice: 0,
      couponCodeInput: "",
      couponCodeApplied: false,
    };
  },
  computed: {
    ...mapFields([
      "generalInfo.contractFor",
      "insuranceProperty.chosenInsurancePrice",
      "insurancePersonalGoods.calculatedInsurancePrice",
      "insurancePersonalGoods.acceptCalculatedInsurance",
      "insurancePersonalGoods.priceType",
      "insurancePersonalGoods.allGoodsPrice",
      "chooseableAccesories.valuablesAbove200",
      "chooseableAccesories.valuablesAboveInputs",
      "chooseableAccesories.accidentInsuranceType",
      "electronicContact",
      "electronicInsuring",
      "ageDiscount",
      "couponCode",
      "businessDiscount",
      "merchant_id",
      "upol",
      "uzletpolitikai_max",
      "fieldErrors",
    ]),
    ...mapFields({
      sideBuildings: "insuranceSideBuildings.list",
      accesoriesList: "chooseableAccesories.selectableList",
      insuredPersonTemplate: "chooseableAccesories.travelInsuranced.template",
      insuredPersons: "chooseableAccesories.travelInsuranced.list",
      paymentType: "paymentOptions.type",
      paymentFrequency: "paymentOptions.frequency",
      eves_dij_csokkentett: "kieg_kedv_dij",
      gyakorisagdij: "gyakorisag_dij_havi",
      contractReason: "kotes_oka",
      oldContructNumber: "regi_kotvenyszam",
      bankAccountNumber: "contractSettings.bankAccountNumber",
      bankName: "contractSettings.bankName",
      bankAccountHolderName: "contractSettings.bankAccountHolderName",
      bankCodeList: "bankCodes",
    }),
    canChooseMonthlyPayment() {
      return !(this.gyakorisagdij < 2000);
    },
    recalculateProperties() {
      return `${this.paymentType}|${this.paymentFrequency}|${this.electronicContact}|${this.electronicInsuring}|${this.businessDiscount}`;
    },
  },
  methods: {
    ...mapActions(["verifyPage"]),
    checkCouponCode() {
      this.$store.dispatch("verifyPage");
    },
    async handleCouponCode() {
      if (this.couponCodeApplied) {
        this.couponCodeInput = "";
        this.couponCode = "";
        this.couponCodeApplied = false;

        this.$store.commit("setFieldErrors", {});

        await this.$nextTick();

        await this.verifyPage(this.$store.state.page);

        return;
      }

      if (!this.couponCodeInput.trim()) {
        return;
      }

      this.couponCode = this.couponCodeInput.trim();

      await this.$nextTick();

      const { data: result } = await this.verifyPage(this.$store.state.page);

      const couponError = result?.fieldErrors?.kedvezmenykod;

      if (couponError !== "Nem létező kedvezménykód") {
        this.couponCodeApplied = true;
      }
    },
  },
  watch: {
    paymentFrequency: function(value) {
      if (value == "havi" && !this.canChooseMonthlyPayment)
        this.paymentFrequency = "negyedeves";
    },
    contractReason: function(value) {
      if (value == "uj_szerzodes") this.oldContructNumber = "";
    },
    bankAccountNumber: function(newValue, oldValue) {
      if (newValue.length >= 3) {
        if (
          newValue.slice(0, 3) in this.bankCodeList &&
          newValue.slice(0, 3) !== oldValue.slice(0, 3)
        ) {
          this.$store.commit("updateContractSettings", {
            name: "bankName",
            value: this.bankCodeList[parseInt(newValue.slice(0, 3))],
          });
        }
      }
      if (newValue.length < 3) {
        this.$store.commit("updateContractSettings", {
          name: "bankName",
          value: "",
        });
      }
      if (!(newValue.slice(0, 3) in this.bankCodeList)) {
        this.$store.commit("updateContractSettings", {
          name: "bankName",
          value: "",
        });
      }
    },
    recalculateProperties: function(value) {
      this.verifyPage();
    },
  },
  mounted() {
    if (this.paymentFrequency == "havi" && !this.canChooseMonthlyPayment)
      this.paymentFrequency = "negyedeves";
  },
};
</script>
